import { useSelector as useSelectorRedux } from 'react-redux';

import { ISelector } from '../interfaces/ISelector';

export function useNamespaceSelector <TState, TResult> (selector: ISelector<TState, TResult>, ...args: any[]): TResult {
    return useSelectorRedux((state: any): TResult => {
        return selector(state, ...args);
    });
}